function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 18a.5.5 0 01-.5.5h-5.732A6.518 6.518 0 0110.19 20H17a2 2 0 002-2V7.828a2 2 0 00-.586-1.414L12.585.586a.492.492 0 00-.049-.04.627.627 0 01-.036-.03 2.072 2.072 0 00-.219-.18.651.651 0 00-.08-.044l-.048-.024-.05-.029c-.054-.031-.109-.063-.166-.087a1.977 1.977 0 00-.624-.138c-.02-.001-.04-.004-.059-.007A.605.605 0 0011.172 0H5a2 2 0 00-2 2v7.498c.474-.198.977-.34 1.5-.422V2a.5.5 0 01.5-.5h6V6a2 2 0 002 2h4.5v10zm-5-15.379L16.378 6.5H13a.5.5 0 01-.5-.5V2.621z",
  fill: "#8F90A6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 15.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.146-2.354a.5.5 0 00-.708 0L4.5 16.793l-1.646-1.647a.5.5 0 00-.708.708l2 2a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z",
  fill: "#8F90A6"
});

function SvgApprovalAccepted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgApprovalAccepted;